let resumeData = {
  imagebaseurl: "images/joe.jpg",
  name: "Joe Ha",
  role: "Software Developer",
  roleDescription: "Software Developer",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/joe-ha/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/jha8",
      className: "fa fa-github",
    },
  ],
  aboutme:
    "Hello world! 👋 🌎 I’m a fullstack developer at Alberta Motor Association. I love learning new technologies and have nearly a year of industry experience in designing and building web and mobile applications. My interests lie in machine learning, full stack and mobile development.",
  address: "Canada",
  education: [
    {
      UniversityName: "University of Alberta",
      specialization: "Bachelor of Science Specialization in Computing Science",
      MonthOfPassing: "",
      YearOfPassing: "2022",
      Achievements:
        "Dean’s Honor Roll, Jason Lang Scholarship, Faculty of Science Entrance Scholarship",
    },
  ],
  work: [
    {
      CompanyName: "AMA - Alberta Motor Association",
      specialization: "Software Developer",
      MonthOfLeaving: "Apr 2022 -",
      YearOfLeaving: "Present",
      bulletSkills: [
        {
          skills: [
            {
              name: "Skills: Angular, .Net Core, Azure",
            },
          ],
        },
      ],
    },
    {
      CompanyName: "S&T Properties",
      specialization: "Junior Software Developer",
      MonthOfLeaving: "Jan 2022 -",
      YearOfLeaving: "Apr 2022",
      bulletSkills: [
        {
          bulletHeader: "Clean Over Team",
          skills: [
            {
              name: "Internal tooling for rental property management including automation of maintenance, cleaning and employee scheduling. For over 200+ properties in North America.",
            },
            {
              name: "Skills: NextJS, NestJS, Azure, GraphQL",
            },
          ],
        },
      ],
    },
    {
      CompanyName: "Ghostlab",
      specialization: "Full Stack Developer Intern",
      MonthOfLeaving: "Sept 2022 -",
      YearOfLeaving: "Dec 2022",
      bulletSkills: [
        {
          bulletHeader: "ATM2 Team",
          skills: [
            {
              name: "Worked on ATM Software used by 200+ Bitcoin ATMs across Canada. Implement new internal operations tooling for asset management.",
            },
            {
              name: "Skills: Angular, NestJS, AWS",
            },
          ],
        },
        {
          bulletHeader: "Bitcoin Well Online Team (Visa Debit)",
          skills: [
            {
              name: "Worked on online Bitcoin purchase system with Visa Debit integration for customers across Canada.",
            },
            {
              name: "Skills: Svelte, NestJS, AWS",
            },
          ],
        },
      ],
    },
    {
      CompanyName: "University of Alberta",
      specialization: "Teaching Assistant - Intro to Software Engineering",
      MonthOfLeaving: "Aug 2022 -",
      YearOfLeaving: "Dec 2022",
      bulletSkills: [
        {
          bulletHeader: "CMPUT 301",
          skills: [
            {
              name: "Instruct weekly software engineering labs with over 90+ students.",
            },
            {
              name: "Covering topics in: Android with Java, unit testing with JUnit, intent testing with Robotium and Espresso, CI with Github Actions.",
            },
          ],
        },
      ],
    },
    {
      CompanyName: "Ghostlab",
      specialization: "Mobile Developer Intern",
      MonthOfLeaving: "May 2022 -",
      YearOfLeaving: "Aug 2022",
      bulletSkills: [
        {
          bulletHeader: "Rise Wallet Team",
          skills: [
            {
              name: "Created and implemented new features for a non custodial Bitcoin Wallet App for iOS and Android users.",
            },
            {
              name: "Skills: Apache Cordova, TypeScript, .Net 5.0 Framework, C#, Android, iOS",
            },
          ],
        },
      ],
    },
  ],
  skills: {
    languages: [
      {
        name: "C++, C#, Python, HTML5, CSS3, JavaScript, TypeScript, SQL",
      },
    ],
    frameworks: [
      {
        name: "React, Django, Apache Cordova, NestJS, Android, Jest, Cypress",
      },
    ],
    tools: [
      {
        name: "Azure, Docker, SonarCloud",
      },
    ],
  },
  portfolio: [
    {
      name: "Citrus Network",
      description:
        "Citrus Network is a social network and blogging application, allowing cross distribution of posts and content to other server nodes. The full stack web application implements a RESTful API using Django and Bootstrap framework for the front end.",
      imgurl: "images/citrus-network.gif",
      links: [
        {
          name: "Github",
          url: "https://github.com/CMPUT404W21H02-Project/Citrus-Network",
          className: "fa fa-github",
        },
        {
          name: "Demo",
          url: "https://www.youtube.com/watch?v=oQ2qlLydUJ4",
          className: "fa fa-youtube",
        },
      ],
    },
    {
      name: "SU Student Pathways",
      description:
        "SU Student Pathways is a tool for students to answer questions about their university experience. This web app serves as the data collection interface that will be integrated with future Student Union Applications at the University of Alberta. The tech stack includes: Django, MySQL, React JS, Redux, Docker and AWS/Cybera for hosting.",
      imgurl: "images/SUPathways.gif",
      links: [
        {
          name: "Demo",
          url: "https://www.youtube.com/watch?v=vq1j-ZdBF30",
          className: "fa fa-youtube",
        },
      ],
    },
    {
      name: "OrionBot",
      description:
        "OrionBot is a StarCraftII bot programmed using C++. The bot implements a combined rush strategy to play a game of StarCraftII against other players. Win Rate against easy/medium AI is 100%, while for hard AI is 80%.",
      imgurl: "images/OrionBot.gif",
      links: [
        {
          name: "Github",
          url: "https://github.com/asmao7/Cmput350F20Orion",
          className: "fa fa-github",
        },
      ],
    },
    {
      name: "Bon Voyage",
      description:
        "Bon Voyage is an interactive ride hailing android app. Drivers can search for open and recent ride requests, and for riders to post requests for rides. Riders will describe the start and end of their ride and their suggested payment. Drivers will browse for nearby requests and accept ride requests that they are willing to fulfill. Payments made to drivers are in the form of QR codes.",
      imgurl: "images/BonVoyage.png",
      links: [
        {
          name: "Github",
          url: "https://github.com/CMPUT301W20T15/bonvoyage",
          className: "fa fa-github",
        },
        {
          name: "Demo",
          url: "https://www.youtube.com/watch?v=w31DEBnfJmM",
          className: "fa fa-youtube",
        },
      ],
    },
    {
      name: "Open Crime Data in Edmonton",
      description:
        "City of Edmonton using Python, Flask, SQL, Folium and Pandas. The flask app can generate visualizations such as bar plots and map locations using Folium showing the crime rates in Edmonton.",
      imgurl: "images/OpenCrimeEdmonton.png",
      links: [
        {
          name: "Github",
          url: "https://github.com/jha8/opendataproject",
          className: "fa fa-github",
        },
      ],
    },
  ],
};

export default resumeData;
